<template>
  <transition name="fade" appear>
    <div
      class="home"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="busy"
      infinite-scroll-distance="50"
      ref="home"
    >
      <div class="carousel" ref="carousel"  v-if="swiperCarousel">
        <swiper ref="swiper" :options="swiperOption">
          <template v-for="(item, index) in swiperCarousel">
            <swiper-slide :key="index + item.article.id" v-if="item.link">
              <img
                v-if="playVideos === false"
                class="play-icon"
                src="../assets/icon_video@2x.png"
                alt
                ref="playIcon"
                @click="plays($event)"
              >
              <video
               webkit-playsinline
               playsinline
                v-if="item.link"
                :src="item.link"
                :poster="item.article.cover"
                ref="video"
                @click="playVideo($event)"
              ></video>
            </swiper-slide>
            <swiper-slide :key="index + item.article.id" v-else-if="!item.link"  @click="gotoStyle(item.article.id)">
              <img
                v-if="item.article"
                :src="item.article.cover"
                alt
                @click="gotoStyle(item.article.id)"
              >
            </swiper-slide>
          </template>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
      <div class="main-body" ref="main-body">
        <div class="card" v-for="(item) in articleList" :key=" item.title + item.id" @click="gotoStyle(item.id)">
          <img :src="util(item.cover)" alt="">
          <!-- <div class="over-lay">
            <div>{{item.title}}</div>
          </div> -->
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Api from '@/network/getList'
export default {
  name: 'style',
  data () {
    return {
      swiperCarousel: null,
      homeData: null,
      swiperInfo: [],
      datas: null,
      articleList: null,
      loading: true,
      page: 0,
      size: 3,
      scrolling: false,
      busy: false,
      videoData: null,
      playVideos: false,
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 6000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  mounted () {
    this.getCarousel()
    this.getHomeData()
    this.getArticleList()
    this.postAccessLog()
    // eslint-disable-next-line
    gdt('track', 'VIEW_CONTENT', { 'page': '首页' })
  },
  updated () {
    window.addEventListener('scroll', () => {
      var list = this.$refs.programsCard
      if (list && list.length) {
        for (var i = 0; i < list.length; i++) {
          if ((window.scrollY + window.screen.height) >= list[i].offsetTop && list[i].offsetTop > window.screen.height) {
            list[i].classList.add('animation')
          } else {
            list[i].classList.remove('animation')
          }
        }
      }
    })
  },
  methods: {
    getCarousel () {
      return Api.getCarouselVideo().then(res => {
        if (res.data.data.length !== 0) {
          this.swiperCarousel = res.data.data
        }
      })
    },
    getHomeData () {
      return Api.getHomeData().then(res => {
        this.homeData = res.data.data.content
      })
    },
    gotoStyle (id) {
      Api.getStyleDetail(id).then(res => {
        this.articleList = res.data.data.photoSets
        if (this.articleList.length === 1) {
          const itemId = this.articleList[0].id
          this.$router.push(`/style/exhibition/${id}?itemId=${itemId}`)
        } else {
          this.$router.push(`/style/${id}`)
        }
      })
    },
    getArticleList () {
      Api.getStyleList({ page: this.page, size: this.size }).then(res => {
        console.log('res: ', res)
        this.articleList = res.data.data.content
        this.totalPage = res.data.data.totalPages
      })
    },
    loadMore: function () {
      if (this.page < this.totalPage && !this.busy) {
        this.busy = true
        this.page++
        Api.getStyleList({ page: this.page, size: this.size }).then(res => {
          if (this.articleList) {
            this.articleList = [...this.articleList, ...res.data.data.content]
          }
          this.busy = false
        }).catch(() => {
          this.busy = false
        })
      }
    },
    postAccessLog () {
      return Api.postAccessLog().then(res => {})
    },
    goUp () {
      if (this.$refs.carousel) {
        this.$refs.carousel.scrollIntoView({
          behavior: 'smooth'
        })
      } else {
        document.body.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        })
      }
    },
    plays (e) {
      var video = e.target.nextElementSibling
      this.playVideos = !this.playVideos
      if (video.paused) {
        video.play()
        if (/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
          video.play()
          this.$refs.swiper.swiper.autoplay.stop()
          video.onpause = () => {
            this.playVideos = false
            this.$refs.swiper.swiper.autoplay.start()
          }
        } else {
          video.play()
          this.$refs.swiper.swiper.autoplay.stop()
          video.controls = true
          video.onpause = () => {
            this.playVideos = !this.playVideos
            video.controls = false
            this.$refs.swiper.swiper.autoplay.start()
          }
        }
      } else {
        video.pause()
      }
    },
    playVideo (e) {
      this.playVideos = !this.playVideos
      if (this.playVideos) {
        if (/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
          e.target.play()
          this.$refs.swiper.swiper.autoplay.stop()
          e.target.onpause = () => {
            this.playVideos = false
            this.$refs.swiper.swiper.autoplay.start()
          }
        } else {
          e.target.play()
          // this.swiperOption.loop = false
          this.$refs.swiper.swiper.autoplay.stop()
          e.target.controls = true
          e.target.onpause = () => {
            this.playVideos = !this.playVideos
            e.target.controls = false
            this.$refs.swiper.swiper.autoplay.start()
          }
        }
      } else {
        // e.target.pause()
        this.playVideos = !this.playVideos
        e.target.pause()
      }
    },
    util (item) {
      return item + '?x-oss-process=image/resize,w_1920,limit_1/auto-orient,1'
    }
  }
}
</script>
<style lang="less" scoped>
img {
  cursor:pointer;
}
html,body{ overflow:scroll; min-height:101%;}
html{ overflow:-moz-scrollbars-vertical;}
.fade-enter-active {
  opacity: 1;
  transition: all 1s;
}
.fade-enter {
  opacity: 0;
}
// img {
//   transition: transform 1s;
// }
// img:hover {
//   transform: scale(1.1);
// }
/deep/ .swiper-pagination-bullet{
  width: 0.6rem;
  height: 0.6rem;
}
.carousel {
  width: 100vw;
  height: 56.25vw;
  position: relative;
  .swiper-container.swiper-container-horizontal,
  .swiper-wrapper,
  .swiper-slide {
    width: 100%;
    height: 100%;
  }
  .swiper-slide {
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      &:hover {
        transform: unset;
      }
    }
    .over-lay{
      position: absolute;
      width: 100%;
      height: 100%;
    }
    video {
      width: 100%;
      height: 100%;
      object-fit: inherit;
      cursor: pointer;
      z-index: 2;
    }
    .play-icon {
      position: absolute;
      width: 5rem;
      height: 5rem;
      z-index: 2;
      cursor: pointer !important;
      top: calc(45% - 3.5rem);
      left: calc(50% - 2.5rem);
    }
  }
  .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
    left: 30px;
    bottom: 6vw;
    top: unset;
    left: 7vw;
    background-image: url('../assets/ic_left@2x.png');
    width: 47px;
    height: 47px;
    background-size: 47px 47px;
  }
  .swiper-button-next, .swiper-container-rtl .swiper-button-prev{
    left: 30px;
    bottom: 6vw;
    top: unset;
    left: calc(7vw + 59px);
    background-image: url('../assets/ic_right@2x.png');
    width: 47px;
    height: 47px;
    background-size: 47px 47px;
  }
  .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets{
    display: none;
  }
}
.main-body{
  padding: 3.75rem 8rem 5rem;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-flow: wrap;
  margin-top: 2rem;
  justify-content: space-evenly;
  .card{
    width: calc((100vw - 24rem) / 3);
    height: calc(((100vw - 24rem) / 6) * 3);
    // margin-right: 3.19rem;
    border-radius: 15px;
    position: relative;
    cursor: pointer;
    &:nth-of-type(3n){
      margin-right: unset;
    }
    &:nth-of-type(n+4) {
      margin-top: 3.19rem;
    }
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: unset;
      border-radius: 15px;
    }
    .over-lay{
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(1, 1, 1, 0.33);
      top: 0;
      left: 0;
      border-radius: 15px;
      div{
        position: absolute;
        top: 50%;
        left: 50%;
        width: 85%;
        text-align: center;
        transform: translateX(-50%) translateY(-50%);
        color: white;
        border-radius: 15px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFangSC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:25px;
      }
    }
  }
}
@media screen and (min-width: 1688px){
  .main-body{
    padding: 3.75rem 20rem 5rem;
    .card{
      width: calc((100vw - 48rem) / 3);
      height: calc(((100vw - 48rem) / 6) * 3);
    }
  }
}
@media screen  and (max-width: 768px){
  .carousel{
    width: 100vw;
    height: 100vw;
    .swiper-button-prev,.swiper-button-next{
      display: none;
    }
  }
  .main-body{
    padding: 1.88rem 1.25rem;
    display: block;
    .card{
      width: calc(100vw - 2.5rem);
      height: calc(((100vw - 2.5rem) / 2) * 3);
      margin-right: unset;
      margin-bottom: 1.88rem;
      &:nth-of-type(3n){
        margin-right: unset;
      }
      &:nth-of-type(n+4) {
        margin-top: unset;
      }
      &:nth-of-last-type(1) {
        margin-bottom: unset;
      }
      .over-lay{
        div{
          width: 80%;
        }
      }
    }
  }
}
</style>
